import React from "react";
import { NavLink } from "react-router-dom"
import Logo from './logo'

import './header.css'

const Header = () => {
    return (
        <header className='header'>
            <div className='content'>
                <Logo />
                <ul className='header-menu'>
                    <NavLink to="/join" activeClassName="active">入驻游戏</NavLink><hr />
                    <NavLink to="/home" activeClassName="active">关于我们</NavLink><hr />
                    <NavLink to="/games" activeClassName="active">游戏</NavLink><hr />
                    <NavLink to="/contact" activeClassName="active">联系我们</NavLink>
                </ul>
            </div>
        </header>)
}

export default Header
